import { MePassengerOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryErrorHandler, silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

const fetchUser = () => passengerApi.post<void, MePassengerOutput>('/authentication/v1/user/me');

export const useFetchUser = (
  options: Omit<UseQueryOptions<MePassengerOutput, unknown, MePassengerOutput, string[]>, 'queryKey' | 'queryFn'> = {},
  silent = true,
) =>
  useQuery(queryKeys.user.me(), fetchUser, {
    staleTime: Infinity,
    cacheTime: Infinity,
    onError: silent ? silentQueryErrorHandler : queryErrorHandler,
    ...options,
  });
